// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/yogas.yaml

export interface Yoga {
  id: string;
  name_en: string;
  name_hi: string;
  description: string;
  effects_en: string;
  effects_hi: string;
  involved_planets: string[];
  detection_type: string;
  /** Optional fields that vary by yoga type */
  [key: string]: unknown;
}

export const yogas: readonly Yoga[] = [
  {
    id: "gajakesari",
    name_en: "Gajakesari Yoga",
    name_hi: "गजकेसरी योग",
    description: "Jupiter in kendra (1st, 4th, 7th, or 10th house) from Moon",
    effects_en: "Wisdom, reputation, wealth, respect in society",
    effects_hi: "बुद्धि, प्रतिष्ठा, धन, समाज में सम्मान",
    involved_planets: ["jupiter", "moon"],
    detection_type: "kendra_from_planet",
    base_planet: "moon",
    target_planet: "jupiter",
    required_houses_from_base: [1, 4, 7, 10],
  },
  {
    id: "budhaditya",
    name_en: "Budhaditya Yoga",
    name_hi: "बुधादित्य योग",
    description: "Sun and Mercury in the same house",
    effects_en: "Intelligence, eloquence, sharp mind, fame through learning",
    effects_hi: "बुद्धि, वाक्पटुता, तीक्ष्ण मन, विद्या से प्रसिद्धि",
    involved_planets: ["sun", "mercury"],
    detection_type: "conjunction",
  },
  {
    id: "hamsa",
    name_en: "Hamsa Yoga",
    name_hi: "हंस योग",
    description: "Jupiter in kendra in own sign (Dhanu/Meen) or exalted (Kark)",
    effects_en: "Spiritual wisdom, virtuous, respected, handsome, long-lived",
    effects_hi: "आध्यात्मिक ज्ञान, सद्गुणी, सम्मानित, सुंदर, दीर्घायु",
    involved_planets: ["jupiter"],
    detection_type: "pancha_mahapurusha",
    planet: "jupiter",
    own_signs: ["dhanu", "meen"],
    exaltation_sign: "kark",
    kendra_houses: [1, 4, 7, 10],
  },
  {
    id: "malavya",
    name_en: "Malavya Yoga",
    name_hi: "मालव्य योग",
    description: "Venus in kendra in own sign (Vrishabh/Tula) or exalted (Meen)",
    effects_en: "Luxury, beauty, artistic talent, comfortable life, vehicles",
    effects_hi: "विलासिता, सौंदर्य, कला प्रतिभा, सुखी जीवन, वाहन",
    involved_planets: ["venus"],
    detection_type: "pancha_mahapurusha",
    planet: "venus",
    own_signs: ["vrishabh", "tula"],
    exaltation_sign: "meen",
    kendra_houses: [1, 4, 7, 10],
  },
  {
    id: "ruchaka",
    name_en: "Ruchaka Yoga",
    name_hi: "रुचक योग",
    description: "Mars in kendra in own sign (Mesh/Vrishchik) or exalted (Makar)",
    effects_en: "Courage, leadership, command over armies, valor, athletic",
    effects_hi: "साहस, नेतृत्व, सेनापति, वीरता, शारीरिक बल",
    involved_planets: ["mars"],
    detection_type: "pancha_mahapurusha",
    planet: "mars",
    own_signs: ["mesh", "vrishchik"],
    exaltation_sign: "makar",
    kendra_houses: [1, 4, 7, 10],
  },
  {
    id: "sasa",
    name_en: "Sasa Yoga",
    name_hi: "शश योग",
    description: "Saturn in kendra in own sign (Makar/Kumbh) or exalted (Tula)",
    effects_en: "Authority, power over others, wealth through discipline, political success",
    effects_hi: "अधिकार, शासन, अनुशासन से धन, राजनीतिक सफलता",
    involved_planets: ["saturn"],
    detection_type: "pancha_mahapurusha",
    planet: "saturn",
    own_signs: ["makar", "kumbh"],
    exaltation_sign: "tula",
    kendra_houses: [1, 4, 7, 10],
  },
  {
    id: "bhadra",
    name_en: "Bhadra Yoga",
    name_hi: "भद्र योग",
    description: "Mercury in kendra in own sign (Mithun/Kanya) or exalted (Kanya)",
    effects_en: "Intellect, communication mastery, business acumen, learned",
    effects_hi: "बुद्धि, संवाद कुशलता, व्यापार दक्षता, विद्वान",
    involved_planets: ["mercury"],
    detection_type: "pancha_mahapurusha",
    planet: "mercury",
    own_signs: ["mithun", "kanya"],
    exaltation_sign: "kanya",
    kendra_houses: [1, 4, 7, 10],
  },
  {
    id: "chandra_mangal",
    name_en: "Chandra-Mangal Yoga",
    name_hi: "चंद्र-मंगल योग",
    description: "Moon and Mars in the same house",
    effects_en: "Wealth through effort, enterprising, prosperous through hard work",
    effects_hi: "परिश्रम से धन, उद्यमशील, कठिन परिश्रम से समृद्ध",
    involved_planets: ["moon", "mars"],
    detection_type: "conjunction",
  },
  {
    id: "dhana",
    name_en: "Dhana Yoga",
    name_hi: "धन योग",
    description:
      "Lord of 2nd house and lord of 11th house in kendra or trikona, or in mutual aspect",
    effects_en: "Wealth accumulation, financial prosperity, multiple income sources",
    effects_hi: "धन संचय, आर्थिक समृद्धि, आय के अनेक स्रोत",
    involved_planets: [],
    detection_type: "dhana",
  },
  {
    id: "adhi",
    name_en: "Adhi Yoga",
    name_hi: "अधि योग",
    description: "Benefics (Jupiter, Venus, Mercury) in 6th, 7th, and 8th houses from Moon",
    effects_en: "Leadership, comfortable life, polite, trustworthy, health and longevity",
    effects_hi: "नेतृत्व, सुखी जीवन, विनम्र, विश्वसनीय, स्वास्थ्य एवं दीर्घायु",
    involved_planets: ["jupiter", "venus", "mercury"],
    detection_type: "adhi",
    benefics: ["jupiter", "venus", "mercury"],
    required_houses_from_moon: [6, 7, 8],
  },
  {
    id: "raja",
    name_en: "Raja Yoga",
    name_hi: "राज योग",
    description:
      "Lord of a kendra and lord of a trikona in sambandha (conjunction, mutual aspect, or sign exchange)",
    effects_en: "Authority, social elevation, command over resources and respect",
    effects_hi: "अधिकार, सामाजिक उत्थान, संसाधनों और सम्मान पर प्रभुत्व",
    involved_planets: [],
    detection_type: "lord_relation",
  },
  {
    id: "vipreet_raja",
    name_en: "Viparita Raja Yoga",
    name_hi: "विपरीत राज योग",
    description: "A dusthana lord (6th/8th/12th) placed in another dusthana",
    effects_en: "Unexpected rise through adversity; gains after others' setbacks",
    effects_hi: "विपत्ति से अप्रत्याशित उत्थान; संघर्ष के बाद लाभ",
    involved_planets: [],
    detection_type: "dusthana_lords",
  },
  {
    id: "neecha_bhanga",
    name_en: "Neecha Bhanga Raja Yoga",
    name_hi: "नीच भंग राज योग",
    description:
      "A debilitated planet whose fall is cancelled — its sign lord or the planet exalted in that sign stands in a kendra from lagna or Moon",
    effects_en: "Reversal of weakness into strength; late-blooming success",
    effects_hi: "दुर्बलता का बल में परिवर्तन; विलंबित किंतु बड़ी सफलता",
    involved_planets: [],
    detection_type: "neecha_bhanga",
  },
  {
    id: "lakshmi",
    name_en: "Lakshmi Yoga",
    name_hi: "लक्ष्मी योग",
    description: "The 9th lord in own or exaltation sign, placed in a kendra or trikona",
    effects_en: "Wealth, fortune, grace; prosperity that feels destined",
    effects_hi: "धन, भाग्य, अनुग्रह; नियति जैसी समृद्धि",
    involved_planets: [],
    detection_type: "ninth_lord_strong",
  },
  {
    id: "saraswati",
    name_en: "Saraswati Yoga",
    name_hi: "सरस्वती योग",
    description:
      "Jupiter, Venus and Mercury together in a kendra, trikona or the 2nd house, with Jupiter in own sign or exalted",
    effects_en:
      "Mastery of learning, eloquence and the arts; a sharp, cultured intellect and fame through knowledge",
    effects_hi:
      "विद्या, वाक्पटुता और कला में निपुणता; तीक्ष्ण सुसंस्कृत बुद्धि और ज्ञान से प्रसिद्धि",
    involved_planets: ["jupiter", "venus", "mercury"],
    detection_type: "saraswati",
  },
  {
    id: "sunapha",
    name_en: "Sunapha Yoga",
    name_hi: "सुनफा योग",
    description: "A planet other than the Sun and the nodes in the 2nd house from the Moon",
    effects_en: "Self-earned wealth, intelligence, steady reputation",
    effects_hi: "स्वअर्जित धन, बुद्धिमत्ता, स्थिर प्रतिष्ठा",
    involved_planets: [],
    detection_type: "moon_flank",
    flank: "second",
  },
  {
    id: "anapha",
    name_en: "Anapha Yoga",
    name_hi: "अनफा योग",
    description: "A planet other than the Sun and the nodes in the 12th house from the Moon",
    effects_en: "Good health, character, and renown; comfort without arrogance",
    effects_hi: "उत्तम स्वास्थ्य, चरित्र और यश; अहंकार रहित सुख",
    involved_planets: [],
    detection_type: "moon_flank",
    flank: "twelfth",
  },
  {
    id: "durudhura",
    name_en: "Durudhura Yoga",
    name_hi: "दुरुधरा योग",
    description:
      "Planets other than the Sun and the nodes on BOTH sides of the Moon (2nd and 12th from it)",
    effects_en: "Wealth, vehicles, generous nature; support from all sides",
    effects_hi: "धन, वाहन, उदार स्वभाव; चारों ओर से सहयोग",
    involved_planets: [],
    detection_type: "moon_flank",
    flank: "both",
  },
  {
    id: "kemadruma",
    name_en: "Kemadruma Yoga",
    name_hi: "केमद्रुम योग",
    description:
      "The Moon with no planets flanking it (2nd/12th from it), none conjunct, and no kendra-from-Moon cancellation — a lonely Moon",
    effects_en:
      "Struggles with mental peace and stability of fortune unless cancelled; upay strengthens the Moon",
    effects_hi: "मानसिक शांति और भाग्य की स्थिरता में संघर्ष; उपाय से चंद्र बल मिलता है",
    involved_planets: ["moon"],
    detection_type: "moon_isolation",
  },
] as const;

export const yogaMap: Readonly<Record<string, Yoga>> = Object.fromEntries(
  yogas.map((y) => [y.id, y])
);
